import React from 'react'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'

const Thumbnail = ({ className, image, alt }) => {
  return <GatsbyImage className={className ? className : `overflow-hidden rounded-t-sm group-hover:scale-110 transition duration-500 ease-in-out`} image={getImage(image)} alt={alt || ''} />
}

export default Thumbnail
